import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useApi } from "@/lib/api";

export default function ResendForm({ q, onDone }) {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(q.detail);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      const r = await api("post", `/queries/${q.thread}/resend`, { detail, note });
      r.email === "sent" ? toast.success(`Resent to ${q.supplier}`) : toast.warning(`Saved, email ${r.email}`);
      setOpen(false); setNote(""); onDone();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (!open) return (
    <Button variant="outline" className="w-full" onClick={() => { setDetail(q.detail); setOpen(true); }} data-testid="query-edit-resend-open">
      <Send className="mr-2 h-4 w-4" /> Edit wording & resend
    </Button>
  );
  return (
    <div className="space-y-3 rounded-2xl border border-teal-200 bg-teal-50/50 p-4" data-testid="query-resend-form">
      <p className="text-sm font-semibold">Edit & resend to {q.supplier}</p>
      <div className="space-y-1.5"><Label>Query wording</Label>
        <Textarea rows={4} value={detail} onChange={(e) => setDetail(e.target.value)} data-testid="query-resend-detail" /></div>
      <div className="space-y-1.5"><Label>Extra message (optional)</Label>
        <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Please could you send a credit note for this by Friday." data-testid="query-resend-note" /></div>
      <p className="text-xs text-slate-500">Sent in the same email thread. Reminders restart from today.</p>
      <div className="flex gap-2">
        <Button variant="ghost" onClick={() => setOpen(false)} data-testid="query-resend-cancel">Cancel</Button>
        <Button className="flex-1" onClick={send} disabled={busy || !detail.trim()} data-testid="query-resend-button">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Resend email
        </Button>
      </div>
    </div>
  );
}
